// import { Helmet } from "react-helmet-async";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";





import { blogService } from "../pages/publicservice/BlogsService";

import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";
const API_PATH = process.env.REACT_APP_API_PATH;

interface Blog {
  blogID: number;
  blogTitle: string;
  blogSlug: string;
  shortDescription: string;
  blogContent: string;
  blogImage: string;
  authorName: string;
  publishDate: string;
  tags?: string;

  metaTitle?: string;
  metaDescription?: string;
  metaKeywords?: string;
  canonicalUrl?: string;

  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;

  schemaMarkup?: string;
}

const BlogDetails = () => {

  const { slug } = useParams();

  const [blog, setBlog] =
    useState<Blog | null>(null);

    const [recentPosts, setRecentPosts] =
  useState<Blog[]>([]);
  const [previousPost, setPreviousPost] =
  useState<Blog | null>(null);

const [nextPost, setNextPost] =
  useState<Blog | null>(null);

  useEffect(() => {
    loadBlog();
  }, [slug]);

async function loadBlog() {
  try {
    const data = await blogService.getAll();

    // Find current blog index
    const currentIndex = data.findIndex(
      (b: Blog) => b.blogSlug === slug
    );

    const selected = data[currentIndex];

    if (selected) {
      setBlog({
        ...selected,
        blogImage: selected.blogImage || ""
      });
    }

    // Recent posts
    const recent = data
      .filter((b: Blog) => b.blogSlug !== slug)
      .slice(0, 3);

    setRecentPosts(recent);

    // Previous post
    setPreviousPost(
      currentIndex > 0
        ? data[currentIndex - 1]
        : null
    );

    // Next post
    setNextPost(
      currentIndex < data.length - 1
        ? data[currentIndex + 1]
        : null
    );

  } catch (error) {
    console.log(error);
  }
}
  if (!blog) {

    return (
      <div className="container py-5 text-center">
        Loading...
      </div>
    );

  }
  return (
    <>
{/* <Helmet>
  <title>
    {blog?.metaTitle || blog?.blogTitle || "Blog Details"}
  </title>

  <meta
    name="description"
    content={
      blog?.metaDescription ||
      blog?.shortDescription ||
      ""
    }
  />

  <meta
    name="keywords"
    content={
      blog?.metaKeywords ||
      blog?.tags ||
      ""
    }
  />

  <meta
    name="author"
    content={blog?.authorName || ""}
  />
  <link
    rel="canonical"
    href={
      blog?.canonicalUrl ||
      window.location.href
    }
  />

  <meta
    property="og:title"
    content={
      blog?.ogTitle ||
      blog?.metaTitle ||
      blog?.blogTitle ||
      ""
    }
  />

  <meta
    property="og:description"
    content={
      blog?.ogDescription ||
      blog?.metaDescription ||
      blog?.shortDescription ||
      ""
    }
  />

  <meta
    property="og:image"
    content={
      blog?.ogImage ||
      blog?.blogImage ||
      ""
    }
  />

  <meta
    property="og:type"
    content="article"
  />

  <meta
    property="og:url"
    content={window.location.href}
  />




  
  {blog?.schemaMarkup && (
    <script type="application/ld+json">
      {blog.schemaMarkup}
    </script>
  )}
</Helmet> */}

      <MobileMenu />
      <PopupSearch />

      <main className="main">
        <Header />

        {/* Breadcrumb */}
        <div
          className="breadcumb-wrapper"
          data-bg-src="/assets/img/bg/breadcumb-bg-1.jpg"
        >
          <img
            src="/assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
          />

          <div className="container z-index-common">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">Blog Details</h1>

              <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>Blog Details</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Blog Details Section */}
        <section className="space-top space-extra-bottom">
          <div className="container">
            <div className="row">

              {/* Main Content */}
              <div className="col-lg-9">
                <div className="vs-blog blog-style1 blog-single">
                  <div className="blog-img">
                    <img
                      className="img"
                      src={blog.blogImage}
                      alt={blog.blogTitle}
                    />
                  </div>

                  <div className="blog-content">
                    <div className="blog-meta">

                      <Link to="/blog">
                        {blog.authorName}
                      </Link>

                      <span>
                        {new Date(
                          blog.publishDate
                        ).toLocaleDateString()}
                      </span>

                    </div>

                    <h3 className="blog-title">
                      {blog.blogTitle}
                    </h3>
                    <div
                      className="blog-text"
                      dangerouslySetInnerHTML={{
                        __html: blog.blogContent
                      }}
                    />

                  

                    <div className="blog-footer">
                    <div className="tagcloud">
  {Array.isArray(blog.tags)
    ? blog.tags.map((tag: string, index: number) => (
        <Link key={index} to="#">
          {tag}
        </Link>
      ))
    : typeof blog.tags === "string"
    ? blog.tags
        .split(",")
        .map((tag, index) => (
          <Link key={index} to="#">
            {tag.trim()}
          </Link>
        ))
    : null}
</div>

                      <div className="blog-social">
                        <a href="#">IG</a>
                        <a href="#">FB</a>
                        <a href="#">LI</a>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Author Section */}
              <div className="post-admin">

  <div className="post-img">
    <img
      src={
        blog.blogImage ||
        "/assets/img/blog/blog-d-1-8.jpg"
      }
      alt={blog.authorName}
    />
  </div>

  <div className="post-content">

    <h4 className="Amalia">
      {blog.authorName}
    </h4>

    <p className="post-text">
      {blog.shortDescription}
    </p>

    <div className="blog-social">
      <a href="#">IG</a>
      <a href="#">FB</a>
      <a href="#">LI</a>
    </div>

  </div>

</div>

  {/* <div className="post-admin">
                  <div className="post-img">
                    <img
                      src="/assets/img/blog/blog-d-1-8.jpg"
                      alt="author"
                    />
                  </div>

                  <div className="post-content">
                    <h4 className="Amalia">Amalia Elha</h4>

                    <p className="post-text">
                      But I must explain to you how all this mistaken idea of denoucing pleasure and praising pain was born and I will give.
                    </p>
                    <div className="blog-social">
                      <a href="#">IG</a>
                      <a href="#">FB</a>
                      <a href="#">LI</a>
                    </div>
                  </div>
                </div> */}

                {/* Pagination */}
                {/* <div className="post-pagination">
                  <div className="row justify-content-between align-items-center gy-4">
                    <div className="col">
                      <Link
                        className="post-pagi-control"
                        to="/blog-details"
                      >
                        <i className="far fa-long-arrow-left"></i>
                        Previous Post
                      </Link>
                    </div>

                    <div className="col text-end">
                      <Link
                        className="post-pagi-control"
                        to="/blog-details"
                      >
                        Next Post
                        <i className="far fa-long-arrow-right"></i>
                      </Link>
                    </div>
                  </div>
                </div> */}

                           <div className="post-pagination">
  <div className="row justify-content-between align-items-center gy-4">

    <div className="col">

      {previousPost && (
        <Link
          className="post-pagi-control"
          to={`/BlogDetails/${previousPost.blogSlug}`}
        >
          <i className="far fa-long-arrow-left"></i>

          Previous Post
        </Link>
      )}

    </div>

    <div className="col text-end">

      {nextPost && (
        <Link
          className="post-pagi-control"
          to={`/BlogDetails/${nextPost.blogSlug}`}
        >
          Next Post

          <i className="far fa-long-arrow-right"></i>
        </Link>
      )}

    </div>

  </div>
</div>

                {/* Comments */}
                <div className="vs-comments-wrap">
                  <h2 className="blog-inner-title">3 Comments</h2>

                  <div className="vs-post-comment">
                    <div className="comment-avater">
                      <img
                        src="/assets/img/blog/blog-d-1-9.jpg"
                        alt="comment"
                      />
                    </div>

                    <div className="comment-content">
                      <h4 className="name h4">janel grant <span className="commented-on"> December 1, 2025</span></h4>

                      <p className="text">
                        But I must explain to you how all this mistaken ideashwad of denoucing pleasure and praising pain was born and I will give.
                      </p>
                      <a href="blog-details.html" className="replay-btn"><i className="fas fa-reply"></i>Replay</a>
                    </div>

                  </div>
                  <img className="comment-ele" src="/assets/img/shapes/dot-shape-4.svg" alt="dot shape"></img>
                  <ul className="children">
                    <li className="vs-comment-item">
                      <div className="vs-post-comment">
                        <div className="comment-avater">
                          <img src="/assets/img/blog/blog-d-1-10.jpg" alt="Comment Author" />
                        </div>
                        <div className="comment-content">
                          <h4 className="name h4">arecika jonson<span className="commented-on"> December 1, 2025</span></h4>
                          <p className="text">But I must explain to you how all this mistaken ideashwad of denoucing
                            pleasure
                            and praising pain was born and I will give.</p>
                          <a href="blog-details.html" className="replay-btn"><i className="fas fa-reply"></i>Replay</a>
                        </div>
                      </div>
                      <img className="comment-ele" src="/assets/img/shapes/dot-shape-4.svg" alt="dot shape" />
                    </li>
                  </ul>
                </div>


                {/* Comment Form */}
                <div className="vs-comment-form">
                  <h2 className="blog-inner-title">
                    Leave a Reply
                  </h2>

                  <p className="your-email">
                    Your email address will not be published.
                    Required fields are marked *
                  </p>

                  <form>
                    <div className="row gx-20">
                      <div className="col-12 form-group">
                        <textarea
                          className="form-control"
                          placeholder="your comments *"
                        ></textarea>
                      </div>

                      <div className="col-md-6 form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="your name *"
                        />
                      </div>

                      <div className="col-md-6 form-group">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="your email *"
                        />
                      </div>
                      <div className="comment-save-info">
                        <input
                          type="checkbox"
                          id="wp-comment-cookies-consent"
                          name="wp-comment-cookies-consent"
                        />

                        <label htmlFor="wp-comment-cookies-consent">
                          Save my name, email, and website in this browser for the next time I comment.
                        </label>
                      </div>
                      <div className="col-12 form-group mt-3">
                        <button className="vs-btn">
                          Send Message
                          <i className="far fa-arrow-right"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              {/* Sidebar */}
              <div className="col-lg-3">
                <div className="sidebar-area">

                  {/* About Widget */}
                  <div className="widget widget_about">
                    <img
                      src="/assets/img/blog/widget-profile-img-1-1.jpg"
                      alt="about"
                    />

                    <h3>
                      Amalia <span>elha</span>
                    </h3>

                    <p>
                      Lorem ipsum dolor sit amet cons elitsedid
                      that eiusmod aboret dolore
                    </p>
                  </div>

                  {/* Categories */}
                  <div className="widget widget_categories">
                    <h3 className="widget_title">Category</h3>

                    <ul>
                      <li>
                        <Link to="/blog-details">
                          diamond pendant
                        </Link>
                        <span>3</span>
                      </li>

                      <li>
                        <Link to="/blog-details">
                          necklace
                        </Link>
                        <span>3</span>
                      </li>

                      <li>
                        <Link to="/blog-details">
                          woman ring
                        </Link>
                        <span>3</span>
                      </li>
                    </ul>
                  </div>

                  {/* Recent Posts */}
                  <div className="widget">
                    <h3 className="widget_title">
                      Recent Post
                    </h3>

                  <div className="recent-post-wrap">

  {recentPosts.map((post) => (

    <div
      className="recent-post"
      key={post.blogID}
    >
      <div className="media-img">

        <Link
          to={`/BlogDetails/${post.blogSlug}`}
        >
          <img
            src={post.blogImage}
            alt={post.blogTitle}
          />
        </Link>

      </div>

      <div className="media-body">

        <h4 className="post-title">

          <Link
            className="text-inherit"
            to={`/BlogDetails/${post.blogSlug}`}
          >
            {post.blogTitle}
          </Link>

        </h4>

        <div className="recent-post-meta">

          <span>
            {new Date(
              post.publishDate
            ).toLocaleDateString()}
          </span>

        </div>

      </div>
    </div>

  ))}

</div>
                  </div>

                  {/* Tags */}
                  <div className="widget widget_tags">
                    <h3 className="widget_title">Tags</h3>

                    <div className="tagcloud">
                      <Link to="/blog-details">diamond</Link>
                      <Link to="/blog-details">necklace</Link>
                      <Link to="/blog-details">rings</Link>
                      <Link to="/blog-details">wedding ring</Link>
                      <Link to="/blog-details">pendant</Link>

                    </div>
                  </div>
                  <div className="widget widget_tags wow animate__fadeInUp wow-animated">
                    <h3 className="widget_title">
                      Tags
                    </h3>
                    <div className="sidebar-gallery">
                      <div className="gallery-thumb">
                        <img src="/assets/img/widget/gal-1-1.jpg" alt="Gallery Image" className="w-100" />
                        <a href="/assets/img/widget/gal-1-1.jpg" className="popup-image gal-btn"><i className="fal fa-plus"></i></a>
                      </div>
                      <div className="gallery-thumb">
                        <img src="/assets/img/widget/gal-1-2.jpg" alt="Gallery Image" className="w-100" />
                        <a href="/assets/img/widget/gal-1-2.jpg" className="popup-image gal-btn"><i className="fal fa-plus"></i></a>
                      </div>
                      <div className="gallery-thumb">
                        <img src="/assets/img/widget/gal-1-3.jpg" alt="Gallery Image" className="w-100" />
                        <a href="/assets/img/widget/gal-1-3.jpg" className="popup-image gal-btn"><i className="fal fa-plus"></i></a>
                      </div>
                      <div className="gallery-thumb">
                        <img src="/assets/img/widget/gal-1-4.jpg" alt="Gallery Image" className="w-100" />
                        <a href="/assets/img/widget/gal-1-4.jpg" className="popup-image gal-btn"><i className="fal fa-plus"></i></a>
                      </div>
                      <div className="gallery-thumb">
                        <img src="/assets/img/widget/gal-1-5.jpg" alt="Gallery Image" className="w-100" />
                        <a href="/assets/img/widget/gal-1-5.jpg" className="popup-image gal-btn"><i className="fal fa-plus"></i></a>
                      </div>
                      <div className="gallery-thumb">
                        <img src="/assets/img/widget/gal-1-6.jpg" alt="Gallery Image" className="w-100" />
                        <a href="/assets/img/widget/gal-1-6.jpg" className="popup-image gal-btn"><i className="fal fa-plus"></i></a>
                      </div>
                    </div>
                  </div>
                  {/* Search */}
                  <div className="widget search-widget">
                    <h3 className="widget_title">Search</h3>

                    <form className="search-form">
                      <input
                        type="text"
                        placeholder="Type here..."
                        className="search-input"
                      />

                      <button type="submit" className="search-btn">
                        <i className="fa-solid fa-magnifying-glass"></i>
                      </button>
                    </form>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

        <Footer />
        <ScrollToTop />
      </main>
    </>
  );
};

export default BlogDetails;